export class EpUtil {
  static fetchAndInsertCss(url: string, id: string) {
    /*
     * If tag already exists return
     * */
    if (document.getElementById(id)) {
      return;
    }

    // TODO wrap in try catch
    const tagName = 'link';
    const firstLinkEl = document.getElementsByTagName(tagName)[0];

    /*
     * Create link dom element
     * Output: <link rel="stylesheet" type="text/css" href="main.css">
     * */
    const linkEl = document.createElement(tagName);
    linkEl.id = id;
    linkEl.href = url;
    linkEl.rel = 'stylesheet';
    linkEl.type = 'text/css';

    /*
     * Add link tag to top of page if other link tags present
     * */
    if (firstLinkEl) {
      firstLinkEl.parentNode.insertBefore(linkEl, firstLinkEl);
    } else {
      document.getElementsByTagName('head')[0].appendChild(linkEl);
    }
  }

  /*
   * From https://gist.github.com/jed/982883
   * Forked to https://gist.github.com/mhamel06/92eabc59764d34c647d32bcb8e3ab45d in case
   * original gist was changed or taken down.
   * */
  static generateUUID(a?: any) {
    // tslint:disable:no-bitwise
    return a
      ? (a ^ ((Math.random() * 16) >> (a / 4))).toString(16)
      : (([1e7] as any) + -1e3 + -4e3 + -8e3 + -1e11).replace(
          /[018]/g,
          this.generateUUID
        );
    // tslint:enable:no-bitwise
  }

  static returnCopy<T = any>(obj: T): T{
    return JSON.parse(JSON.stringify(obj));
  }

  static injectScriptTag(src: string, dataset: {[key: string]: string} = {}, scriptId: string, async = true){
    /*
    * Don't allow duplicate scripts to be loaded onto a site
    * */
    const existingScript = document.querySelectorAll(`script#${scriptId}`);
    if(existingScript.length > 0){
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = async;
    script.id = scriptId;

    for(const key in dataset){
      if(!!dataset[key]){
        script.dataset[key] = dataset[key];
      }
    }
    document.body.append(script);
  }
}
